import { useEffect, useState, useRef } from 'react';
import Lottie from 'lottie-react';
import homeImageBreakAnimation from '@/assets/home-image-break.json';
import { cn } from '@/lib/utils';

export function ImageBreakSection() {
  const [shouldPlay, setShouldPlay] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldPlay(true);
          setTimeout(() => setIsVisible(true), 100);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={containerRef} 
      className="relative bg-background overflow-hidden py-4 md:py-8 lg:py-20"
    >
      {/* Container extends from left edge to right edge of centered max-w-6xl (1152px) container */}
      <div 
        className="ml-0"
        style={{ width: 'calc(50% + 576px)', maxWidth: '100%' }}
      >
        <div className={cn(
          "transition-opacity duration-1000 ease-out",
          isVisible ? "opacity-100" : "opacity-0"
        )}>
          {shouldPlay ? (
            <Lottie
              animationData={homeImageBreakAnimation}
              loop={false}
              autoplay={true}
              className="w-full h-auto"
            />
          ) : (
            <div className="w-full aspect-[1670/700]" />
          )}
        </div>
      </div>
    </section>
  );
}
